module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img.c0e206c9f6a8ee04624c999c72ef3c31.jpg";